module.exports = __webpack_public_path__ + "static/img/result_ceil_angle.a07c4fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ceil_angle.jpg
// module id = 91J9
// module chunks = 3